"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHomeFolder = getHomeFolder;
exports.makeFolderTree = makeFolderTree;
exports.isFile = isFile;
exports.getFolder = getFolder;
exports.getParentFolderId = getParentFolderId;
exports.getParentFolder = getParentFolder;
exports.getAncestors = getAncestors;
exports.getAncestorsForFile = getAncestorsForFile;
exports.getFilteredByKeyword = getFilteredByKeyword;
exports.filterFolders = filterFolders;
exports.toOrderedMap = toOrderedMap;
exports.filterRecentlyUploadedFiles = exports.getLeafFolderName = exports.getAncestorPaths = exports.pickValidUploadV3Options = void 0;

var _immutable = _interopRequireWildcard(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _stringUtils = require("./stringUtils");

var _pick = _interopRequireDefault(require("./pick"));

var _propTypes = require("../constants/propTypes");

var _Constants = require("../Constants");

var _homeFolder = null;

function getHomeFolder() {
  if (_homeFolder) {
    return _homeFolder;
  }

  _homeFolder = _immutable.default.Map({
    name: _I18n.default.text('FileManagerCore.rootFolder'),
    id: null,
    parent_folder_id: null,
    full_path: '',
    children: new _immutable.default.List()
  });
  return _homeFolder;
}

function findFoldersForParentId(foldersByParentId, parentId) {
  return foldersByParentId.get(parentId, (0, _immutable.List)()).map(function (f) {
    f = f.toJS();
    f.children = findFoldersForParentId(foldersByParentId, String(f.id));
    return f;
  }).toArray();
}

function makeFolderTree(folders) {
  var foldersByParentId = (0, _immutable.OrderedMap)(folders.groupBy(function (f) {
    return f.get('parent_folder_id');
  }));
  var folderTree = findFoldersForParentId(foldersByParentId, null);
  var root = getHomeFolder().toJS();
  root.children = folderTree;
  return root;
}

function isFile(object) {
  if (object.get('category')) {
    return object.get('category') === _Constants.ObjectCategory.FILE;
  }

  return object.has('meta');
}

function getFolder(id, folders) {
  if (folders instanceof _immutable.OrderedMap) {
    return folders.get(id);
  }

  return folders.find(function (folder) {
    return folder.get('id') === id;
  });
}

function getParentFolderId(object) {
  if (!object) {
    return null;
  }

  var folderId = object.get('parent_folder_id') || object.get('folder_id');
  return folderId ? parseInt(folderId, 10) : null;
}

function getParentFolder(object, folders) {
  var parentId = getParentFolderId(object);

  if (!parentId) {
    return getHomeFolder();
  }

  return folders.find(function (folder) {
    return folder.get('id') === parentId;
  }) || getHomeFolder();
}

function getAncestors(folder, folders) {
  var ancestors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new _immutable.default.OrderedMap();

  if (!folder) {
    return ancestors;
  }

  ancestors = ancestors.set(folder.get('id'), folder);

  if (!folder.get('parent_folder_id')) {
    return ancestors.reverse();
  }

  var parentId = parseInt(folder.get('parent_folder_id'), 10);
  var parentFolder = getFolder(parentId, folders);

  if (!parentFolder) {
    return ancestors;
  }

  return getAncestors(parentFolder, folders, ancestors);
}

function getAncestorsForFile(file, folders) {
  var folderId = file.get('folder_id');
  var folder = folders.get(folderId);

  if (!folder) {
    return _immutable.default.OrderedMap();
  }

  return getAncestors(folder, folders);
}

function getFilteredByKeyword(folders, keyword) {
  return folders.filter(function (folder) {
    var folderName = folder.get('name').toLowerCase();
    var searchQuery = keyword.toLowerCase();

    try {
      // decode percent-encoding, which is safe because folder names can't contain %
      searchQuery = window.decodeURIComponent(searchQuery);
    } catch (e) {} // eslint-disable-line no-empty


    return folderName.indexOf(searchQuery) >= 0;
  });
}

function filterFolders(folders, path, keyword) {
  var parentFolderId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  if (keyword) {
    return getFilteredByKeyword(folders, keyword);
  } else if (!path && !parentFolderId) {
    return folders.filter(function (folder) {
      return folder.get('parent_folder_id') === null;
    });
  }

  var parentFolderFromPath;

  if (parentFolderId) {
    parentFolderFromPath = getFolder(parentFolderId, folders);
  } else if (path) {
    parentFolderFromPath = folders.find(function (folder) {
      return folder.get('full_path') === "/" + path || folder.get('full_path') === path;
    });
  }

  if (parentFolderFromPath) {
    return folders.filter(function (folder) {
      return parseInt(folder.get('parent_folder_id'), 10) === parentFolderFromPath.get('id');
    });
  } // [TEMPORARY FIX] if the parent folder is hidden, use the path and regex
  // which may be less reliable since it won't use the parent_folder_id


  return folders.filter(function (folder) {
    var fullPath = folder.get('full_path');
    var regex = new RegExp("\\/" + (0, _stringUtils.escapeRegExp)(folder.get('name')) + "$");
    var basePath = fullPath.replace(regex, '');
    return basePath === "/" + path;
  });
}

function toOrderedMap(objects) {
  return (0, _immutable.OrderedMap)(objects.map(function (f) {
    return [f.get('id'), f];
  }));
}

var pickValidUploadV3Options = function pickValidUploadV3Options() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _pick.default)(options, _propTypes.FILE_UPLOAD_V3_OPTION_KEYS);
};

exports.pickValidUploadV3Options = pickValidUploadV3Options;

var getAncestorPaths = function getAncestorPaths(fullPath) {
  fullPath = (0, _stringUtils.removeLeadingSlashFromPath)(fullPath);
  var pathParts = fullPath.split('/');
  return pathParts.map(function (part, i) {
    return "/" + pathParts.slice(0, i + 1).join('/');
  });
};

exports.getAncestorPaths = getAncestorPaths;

var getLeafFolderName = function getLeafFolderName(fullPath) {
  fullPath = (0, _stringUtils.removeLeadingSlashFromPath)(fullPath);
  var pathParts = fullPath.split('/');
  return pathParts[pathParts.length - 1];
};

exports.getLeafFolderName = getLeafFolderName;
var RECENT_FILE_UPLOAD_THRESHOLD_SECONDS = 10;

var filterRecentlyUploadedFiles = function filterRecentlyUploadedFiles(singleFileDetails, uploadRequestsById, currentFolderId) {
  var threshold = _I18n.default.moment().subtract(RECENT_FILE_UPLOAD_THRESHOLD_SECONDS, 'seconds').valueOf();

  var recentlyUploadedFileIds = uploadRequestsById.filter(function (val) {
    return val.get('timestamp') > threshold;
  }).keySeq().toList();
  var recentlyUploadedFiles = recentlyUploadedFileIds.map(function (id) {
    return singleFileDetails.get(id);
  }).filter(function (f) {
    return f;
  }).map(function (f) {
    return f.set('clientUploadedAt', uploadRequestsById.get(f.get('id')).get('timestamp'));
  });

  if (currentFolderId) {
    if (currentFolderId === 'None') {
      currentFolderId = null;
    }

    recentlyUploadedFiles = recentlyUploadedFiles.filter(function (f) {
      return f.get('folder_id') === currentFolderId;
    });
  }

  return recentlyUploadedFiles;
};

exports.filterRecentlyUploadedFiles = filterRecentlyUploadedFiles;